<div class="qa-document-scan-options">
  <div class="d-flex">
    <div>
      <label class="min-pages-label" for="minPages">{{_(KEYS.EDITOR.DOCUMENT_SCAN_MIN_PAGES)}}</label>
      <input
        class="min-pages-input form-control"
        id="minPages"
        type="number"
        min="1"
        max="100"
        [value]="minPages"
        (input)="onMinPagesChange($event.target.value)"
      />
    </div>
    
    <div class="ml-3">
      <label class="max-pages-label" for="maxPages">{{_(KEYS.EDITOR.DOCUMENT_SCAN_MAX_PAGES)}}</label>
      <input
        class="max-pages-input form-control"
        id="maxPages"
        type="number"
        min="1"
        max="100"
        [value]="maxPages"
        (input)="onMaxPagesChange($event.target.value)"
      />
    </div>
  </div>
</div>
